import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { cancelFutureDatedPayment } from "../../../utils/requests";
import { connect } from "react-redux";
import moment from "moment";
import { usd } from "../../../utils/utils";
import {
  callAuthCancelFutureDatedPayment,
  callAuthGetLoans,
} from "../../../actions/authPayment.actions";
import Show from "../../../utils/show.component";

const FuturePaymentCancellationModalComponent = ({
  show,
  onHide,
  paymentId,
  loanDescription,
  amount,
  date,
  paymentAccount,
  ...rest
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const completeOnHide = () => {
    setLoading(false);
    setError(null);
    onHide();
  };

  const onSuccess = () => {
    completeOnHide();

    // Refresh the loan list to reflect the cancelled payment
    rest.callAuthGetLoans();
  };

  return (
    <div className={`${show ? "active popup-modal loading-modal" : ""}`}>
      <div className="dark-bg"></div>
      <div className="modal px-1" style={{ minHeight: "fit-content", position: "fixed" }}>
        <div className="modal-container py-5 px-3 m-auto" style={{ maxWidth: "90%" }}>
          <button
            disabled={loading}
            onClick={completeOnHide}
            className="close-icon d-flex p-0 mr-2"
          >
            <i className="material-icons">close</i>
          </button>
          <div className="bold f24 mb-1">Scheduled Payment</div>
          <div className="f20">{loanDescription}</div>
          <div
            style={{
              fontSize: "12px",
              paddingLeft: "10px",
              paddingRight: "10px",
            }}
          >
            <div style={{ backgroundColor: "darkgray", height: "1px", margin: "10px 0" }}></div>
            <div className="d-flex justify-content-between pb-2">
              <div>Payment Amount</div>
              <div className="bold">{usd.format(amount)}</div>
            </div>
            <div className="d-flex justify-content-between pb-2">
              <div>Scheduled Date</div>
              <div className="bold">{moment(date).format("MM/DD/YYYY")}</div>
            </div>
            <div className="d-flex justify-content-between pb-2">
              <div>Payment Account</div>
              <div className="bold">****{paymentAccount.slice(-4)}</div>
            </div>
            <div
              style={{
                marginTop: "20px",
                marginBottom: "10px",
              }}
            >
              Are you sure you want to cancel the payment scheduled on{" "}
              {moment(date).format("MM/DD/YYYY")}?
            </div>
            <Button
              variant="danger"
              className="w-100"
              disabled={loading}
              style={{
                textWrap: "inherit",
              }}
              onClick={() => {
                setError(null);

                rest.callAuthCancelFutureDatedPayment(paymentId, setLoading, setError, onSuccess);
              }}
            >
              Cancel Scheduled Payment
            </Button>
            <Show condition={error}>
              <div className="error-message mt-3">
                {error || "An error occurred while cancelling your payment. Please try again."}
              </div>
            </Show>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => state;

const mapDispatchToProps = {
  callAuthGetLoans,
  callAuthCancelFutureDatedPayment,
};

export const FuturePaymentCancellationModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FuturePaymentCancellationModalComponent);



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/modal/future-payment-cancellation-modal.js